type ReplacementGenerator = () => string | number;
export type PlaceholderReplacements = {
    [placeholder: string]: string | number | ReplacementGenerator;
};

const replacePlaceholdersInString = (
    stringWithPlaceholders: string,
    placeholderReplacements: PlaceholderReplacements
) => {
    let output = stringWithPlaceholders;
    Object.keys(placeholderReplacements).forEach((placeholder) => {
        let replacement = placeholderReplacements[placeholder];
        if (typeof replacement === 'function') {
            replacement = replacement();
        }
        output = output.replace(placeholder, replacement.toString());
    });
    return output;
};

const replacePlaceholdersInPath = (
    path: PagePath,
    replacements: PlaceholderReplacements
) => {
    return replacePlaceholdersInString(path, replacements);
};

export enum PagePath {
    StockOverview = '/',
    StockDetail = '/vloot/:id',
    StockUpdate = '/vloot/:id/aanpassen',

    ReturnStock = '/voertuig-inleveren/:id',

    Appointment = '/afspraak-maken',
    AppointmentNew = '/afspraak-maken/:id',
    AppointmentEdit = '/vloot/:id/afspraak-bewerken',
}

export const createAppointmentNewRoute = (stockNumber: string) => {
    return replacePlaceholdersInPath(PagePath.AppointmentNew, {
        ':id': stockNumber,
    });
};

export const createAppointmentEditRoute = (stockNumber: string) => {
    return replacePlaceholdersInPath(PagePath.AppointmentEdit, {
        ':id': stockNumber,
    });
};

export const createStockDetailRoute = (stockNumber: string) => {
    return replacePlaceholdersInPath(PagePath.StockDetail, {
        ':id': stockNumber,
    });
};

export const createReturnStockRoute = (stockNumber: string) => {
    return replacePlaceholdersInPath(PagePath.ReturnStock, {
        ':id': stockNumber,
    });
};

export const createStockUpdateRoute = (stockNumber: string) => {
    return replacePlaceholdersInPath(PagePath.StockUpdate, {
        ':id': stockNumber,
    });
};
